import React from "react";
import { Modal, Row, Col, Form, Table } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import "./SparePartsModal.css";

export default function SparePartsModal({ show, onHide, vehicle }) {
    const sparePartsVariants = vehicle.spareParts || [];

    const validationSchema = Yup.object().shape({
        variantId: Yup.string()
            .required("Please select a variant.")
            .notOneOf([""], "Please select a variant.")
    });

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton className="brand-modal-header"></Modal.Header>

            <Formik
                initialValues={{ variantId: "" }}   // 🔥 No default
                validationSchema={validationSchema}
                onSubmit={() => { }}
            >
                {({ values, handleChange, handleBlur, errors, touched }) => {
                    const selectedVariant =
                        sparePartsVariants.find(
                            (variant) => variant.variantId === values.variantId
                        ) || null;

                    return (
                        <Form>
                            <Modal.Body>
                                <h4 className="sparePartsModal-title">Spare Parts</h4>
                                <Row className="mb-3 align-items-center">
                                    {vehicle.imageSrc && (
                                        <img
                                            src={vehicle.imageSrc}
                                            alt={vehicle.title}
                                            className="spare-parts-modal__image"
                                        />
                                    )}

                                    <div className="text-center">
                                        <h5 className="spare-parts-modal__vehicle-title">
                                            {vehicle.title}
                                        </h5>
                                        <p className="spare-parts-modal__inclusive-text">
                                            Inclusive of VAT*
                                        </p>


                                        <Form.Group controlId="variantId" className="mt-2">
                                            <div className="text-center">
                                                <Form.Label className="brand-input-label">Select Variant</Form.Label>
                                            </div>
                                            <Form.Select
                                                className="w-50 mx-auto brand-input"
                                                name="variantId"
                                                value={values.variantId}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select Variant</option> {/* Default */}
                                                {sparePartsVariants.map((variant) => (
                                                    <option
                                                        key={variant.variantId}
                                                        value={variant.variantId}
                                                    >
                                                        {variant.variantName}
                                                    </option>
                                                ))}
                                            </Form.Select>



                                            {errors.variantId && touched.variantId && (
                                                <div className="spare-parts-modal__error">
                                                    {errors.variantId}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </div>

                                </Row>

                                {/* 🔥 Show table ONLY when user selects a variant */}
                                {selectedVariant && (
                                    <div className="spare-parts-modal__table-wrapper">
                                        <Table striped bordered hover responsive size="sm">
                                            <thead>
                                                <tr>
                                                    <th>Description</th>
                                                    <th>Price</th>
                                                    <th>الوصف بالعربية</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedVariant.parts.map((part) => (
                                                    <tr key={part.id}>
                                                        <td>{part.descriptionEn}</td>
                                                        <td>{part.price}</td>
                                                        <td>{part.descriptionAr}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}
                            </Modal.Body>
                        </Form>
                    );
                }}
            </Formik>
        </Modal>
    );
}
